import axios from 'axios';

// These values come from frontend/.env
// REACT_APP_API_URL    = http://localhost/construction-app/backend/api
// REACT_APP_UPLOAD_URL = http://localhost/construction-app/backend/uploads
const API_BASE    = process.env.REACT_APP_API_URL;
const UPLOAD_BASE = process.env.REACT_APP_UPLOAD_URL;

const api = axios.create({ baseURL: API_BASE });

api.interceptors.request.use(cfg => {
  const token = localStorage.getItem('bc_token');
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});

api.interceptors.response.use(
  res => res,
  err => {
    if (err.response?.status === 401) {
      localStorage.removeItem('bc_token');
      localStorage.removeItem('bc_user');
      if (
        window.location.pathname.startsWith('/admin') &&
        window.location.pathname !== '/admin/login'
      ) {
        window.location.href = '/admin/login';
      }
    }
    return Promise.reject(err);
  }
);

export const getImageUrl = (folder, filename) =>
  filename ? `${UPLOAD_BASE}/${folder}/${filename}` : null;

export const getPlaceholder = (w = 800, h = 600, text = '') =>
  `https://placehold.co/${w}x${h}/1a1a1a/c9a84c?text=${encodeURIComponent(text || 'Bacha & Son Construction')}`;

export default api;
